export class SimpleSectionSwitcher{

	static #LIST_SWITCHERS = []
	static get LIST_SWITCHERS(){
		return this.#LIST_SWITCHERS
	}


   	switcherEl
	buttons
	hr
	sectionIdList = []
	activeSections = []

	static init(){
		const switchers = document.getElementsByClassName('switcher');
		for(let sw of switchers){
			if(!sw.hasAttribute('data-init')){
				let switcher = new SimpleSectionSwitcher(sw)
				SimpleSectionSwitcher.#LIST_SWITCHERS.push(switcher)
			}
		}
	}

	constructor(elOrSelector){
		if(typeof elOrSelector === 'string')
			this.switcherEl = document.querySelector(elOrSelector)
		else
			this.switcherEl = elOrSelector
		this.buttons=Array.from(this.switcherEl.getElementsByClassName('switcher-button')).filter(el=>el.hasAttribute('data-section'))
		if(this.buttons){
			let activeButton = this.buttons.find(el=>el.classList.contains('active-switcher-button'))
			if(!activeButton){
				this.buttons[0].classList.add('active-switcher-button')
				activeButton = this.buttons[0]
			}
			this.activeSections = activeButton.getAttribute('data-section').trim().split(/\s+/)
			for(const button of this.buttons){
				this.sectionIdList.push(button.getAttribute('data-section').trim().split(/\s+/))
				button.addEventListener('click',this.switchMenu.bind(this))
			}
			if(!this.switcherEl.hasAttribute('data-area'))
				throw new Error('Switcher element must have a data-area attribute!')
			const areas = this.switcherEl.getAttribute('data-area').trim().split(/\s+/)
			for(let id of areas){
				const container = document.getElementById(id)
				const listSection = Array.from(container.getElementsByClassName('switcher-section'))
				listSection.filter(sc => !this.activeSections.includes(sc.id)).forEach(sc=>sc.setAttribute('style', 'display:none !important;'))
			}
			this.hr = this.switcherEl.querySelector('.switcher-hr')
			if(this.hr){
				this.resizeHr()
				window.addEventListener('resize', this.resizeHr.bind(this))
			}
		}
		this.switcherEl.setAttribute('data-init',true);
		let newEvent = new CustomEvent('init-switcher',{ detail: {switcher: this}});
		this.switcherEl.dispatchEvent(newEvent);
	}

	switchMenu(event, dispatchEvent = true){
		let button
		if(typeof event === 'string'){
			button = document.querySelector(`.switcher-button[data-section="${event}"]`)
		}else if(event instanceof Event){
			button = event.currentTarget;
		}
		if(!button){
			console.error(`switchMenu() don't work`)
			return 
		}
		for(const item of this.buttons){
			if(item!=button&&item.classList.contains('active-switcher-button') && dispatchEvent){
				let newEvent = new CustomEvent('switch',{ detail: {switcher: this, button}});
				this.switcherEl.dispatchEvent(newEvent);
			}
			if(item == button)
				item.classList.add('active-switcher-button')
			else
				item.classList.remove('active-switcher-button')
		}
		const areas = this.switcherEl.getAttribute('data-area').trim().split(/\s+/)
		for(let id of areas){
			const container = document.getElementById(id)
			const listSection = container.getElementsByClassName('switcher-section')
			const listIds=button.getAttribute('data-section').trim().split(/\s+/);
			const activeSections=[]
			for(const section of listSection){
			 	if(listIds.includes(section.id)){
			 		activeSections.push(section)
			 		section.style.display= ''
			 	}
			 	else
			 		section.setAttribute('style', 'display:none !important;')
			}
			this.activeSections = activeSections
			if(dispatchEvent){
				const newEvent = new CustomEvent('afterswitch', {detail: {switcher: this ,button, activeSections}});
				this.switcherEl.dispatchEvent(newEvent);
			}
		}
		this.resizeHr()
	}

	resizeHr(){
		if(this.hr){
			const button = this.buttons.find(btn=>btn.classList.contains('active-switcher-button'))
			const rectFirst = this.buttons[0].getBoundingClientRect()
			const rectItem = button.getBoundingClientRect();
			this.hr.style.left=(rectItem.left-rectFirst.left)+"px";
			this.hr.style.width=rectItem.width+"px";
		}
	}
}
